import { theme } from '../../Theme';
import { css } from 'react-emotion';

export const eztradStyling = css`
  [data-flight-dropdown] {
    [data-flight-dropdown-button],
    [data-flight-dropdown-item],
    [data-flight-dropdown-item] button {
      font-variant: normal;
      text-transform: none;
      font-size: 0.875rem;
      letter-spacing: 0.03em;
      border-color: ${theme.colors.mediumGrey};
      font-weight: 700;
      font-size: 0.875rem;
    }
  }
`;
